import React from 'react';
import './Loading.css';

const Loading = ({ error, message = 'Yükleniyor...' }) => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        {!error && <div className="loading-spinner"></div>}
        <div className={`loading-text ${error ? 'error' : ''}`}>
          {message}
        </div>
      </div>
    </div>
  );
};

export default Loading; 